import React from 'react';

const S360WidgetBlock = ({title, children}) =>
{
    return (
        <div className='pupil-block'>
            <h5 id="group-header">{title}</h5>
            {children}
        </div>
    )
}

export default S360WidgetBlock;